<template lang="pug">
  v-container#other-actions(fluid)
    .d-flex
      .dark-text.bold.py-5 {{ `${actionFolio}. Acción` }}
      .ml-4.underline.text-danger.py-5.small(@click="deleteAction") Borrar
    v-row.no-top-p.align-flex-end
      v-col.mr-9(d-flex xs=12 sm=4)
        v-text-field(
        	v-model="otherAuthority"
        	label="Ante qué otra autoridad se hizo la acción"
        )
      v-col(d-flex xs=6 sm=6)
        v-row.py-1
          label.custom.mb-2  Fecha de acción
        v-row.pt-1.no-top-p
          v-col(d-flex xs=2 sm=2)
            v-select(
              label="Día"
            	:items="days"
            	v-model="actionDateDay"
            )
          v-col(d-flex xs=2 sm=2)
            v-select(
              label="Mes"
              :items="months"
              v-model="actionDateMonth"
            )
          v-col(d-flex xs=3 sm=3)
            v-autocomplete(
              label="Año"
            	:items="years"
            	v-model="actionDateYear"
            )

      v-row.py-5
        v-col(d-flex xs=12 sm=8)
          v-text-field(
          	v-model="description"
          	label="Descripción de la acción: "
          )

</template>

<script>
export default {
  name: "OtherActions",
  props: {
    index: Number,
    action: Object,
  },
  computed: {
    actionFolio() {
      return this.action.folio = this.index + 1;
    },
    days() {
      return this.$store.state.days;
    },
    months() {
      return this.$store.state.months;
    },
    years() {
      return this.$store.state.years;
    },
    otherAuthority: {
    	get() {
    		return this.action.otherAuthority;
    	},
    	set(value) {
    		this.action.otherAuthority = value;
    	}
    },
    actionDateDay: {
    	get() {
    		return this.action.actionDate.day;
    	},
    	set(value) {
    		this.action.actionDate.day = value;
    	}
    },
    actionDateMonth: {
    	get() {
    		return this.action.actionDate.month;
    	},
    	set(value) {
    		this.action.actionDate.month = value;
    	}
    },
    actionDateYear: {
    	get() {
    		return this.action.actionDate.year;
    	},
    	set(value) {
    		this.action.actionDate.year = value;
    	}
    },
    description: {
    	get() {
    		return this.action.description;
    	},
    	set(value) {
    		this.action.description = value;
    	}
    },
  },
  methods: {
    deleteAction() {
      this.$store.state.record.narrative.actions.splice(this.index,1);
    }
  }
};
</script>

<style scoped lang="scss">
.col {
  padding-top: 0px;
  padding-bottom: 0px;
  padding-left: 0px;
}

.no-top-p .v-input {
  padding-top: 0px !important;
}

.v-text-field__details {
  display: none !important;
}

.align-flex-end {
  align-items: flex-end;
}

.text-danger {
  color: red !important;
  cursor: pointer;
}
</style>
